module.exports = fox._r("images/join/chbox.png", __webpack_public_path__ + "images/join/chbox.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/join/chbox.png
// module id = 1063
// module chunks = 4